// Import the centralized API URL from api.ts
import { getTenantHeaders } from '../utils/tenantApiHeaders';
import { apiClient } from './api';

// Use the same base URL as the main API client
const API_BASE_URL = apiClient.getBaseUrl();

const getStoredToken = (): string => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    throw new Error('No auth token');
  }
  return token;
};

interface User {
  email: string;
  name: string;
}

export const getCurrentUser = async (): Promise<User> => {
  const token = getStoredToken();

  const response = await fetch(`${API_BASE_URL}/auth/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...getTenantHeaders(),
    },
  });

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('authToken');
      throw new Error('Authentication expired');
    }
    throw new Error('Failed to get user info');
  }

  return response.json();
};

export const logout = async (): Promise<void> => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getStoredToken()}`,
        ...getTenantHeaders(),
      },
    });

    if (!response.ok) {
      throw new Error('Logout failed');
    }

    // Clear stored token
    localStorage.removeItem('authToken');
  } catch (error) {
    console.error('Logout error:', error);
    // Clear token even if logout request fails
    localStorage.removeItem('authToken');
  }
};

export const initGoogleAuth = (): string => {
  return `${API_BASE_URL}/auth/google`;
};
